module.exports = __webpack_public_path__ + "assets/close-white-02ac50b28d5d54a87027b91a6a1bebbb.svg";